import React from "react";
import WorkspaceKpi from "../../components/WorkspaceKpi";

// Outer margin/grid wrapper removed so the page edges match /company-metrics
// (PageHeader and Dashboard handle their own gutters).
const KpiSettings = () => <WorkspaceKpi />;

export default KpiSettings;
